import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "./reports.css"
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BarLoader, ClipLoader } from 'react-spinners';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { useCurrency } from '../../Layouts/currencyContext';
import { LiaFileExcel } from "react-icons/lia";
import * as XLSX from "xlsx";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL

const PurchaseRequisitionReports = () => {
    const [rowData, setRowData] = useState([]);
    const { currencyprecision } = useCurrency();
    const [currencyPrecision, setPrecision] = useState(currencyprecision?.exp1 || 3);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const [requsitionlist, setRequsitionlist] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [toDate, setToDate] = useState();
    const [fromDate, setFromDate] = useState();
    const [dateFilter, setdateFilter] = useState(true);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const apiService = new ApiService();

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    const StatusFilter = [
        { value: 'All', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Aproved' },
        { value: '2', label: 'Hold' },
        { value: '3', label: 'Rejected' },
    ];
    const requestType = [
        { value: '', label: 'All' },
        // { value: 'Store Request', label: 'Store Request' },
        { value: 'Purchase Requisition', label: 'Purchase Requisition' },
        // { value: 'Purchase Request', label: 'Purchase Request' },
        { value: 'Store Requisition', label: 'Store Requisition' },
    ];
    const gridRef = useRef();
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        email: "",
        fromDate: '',          // Today's date
        toDate: '',
        withoutPo: false,
        RequisitionType: [{ label: 'Select Request Type', value: '0' }],
        StockType: [{ label: 'Select Stock Type', value: '0' }],
        Status: [{ label: 'All', value: '' }],
        RequisitionNo: '',
    });
    const handleClearFilters = () => {
        const today = new Date();
        setFormData({
            RequisitionType: "",
            fromDate: formatDate(today),
            toDate: formatDate(today),
            RequisitionNo: '',
            StockType: [{ label: 'Select Stock Type', value: '0' }],
            Status: [{ label: 'All', value: '' }],
        });
        setdateFilter(false)
    };
    const handleCheckboxChange = (event) => {
        const { checked } = event.target;
        setFormData({ ...formData, withoutPo: checked });
    };
    useEffect(() => {
        // getItems();
        const fetchDropdownData = async () => {
            try {
                // getItems()
                const today = new Date();
                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(today),
                    toDate: formatDate(today),
                }));
                const apiService = new ApiService();
                let param = `?isActive=true`
                let Currencyres = await apiService.get('GET_CURRENCY_MASTER')
                const filteredDenominations = Currencyres?.data?.result?.find(currency => currency?.isDefault === true);
                setPrecision(filteredDenominations?.precision)
                const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
                setStockType(stockType?.data?.result);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
    }, []);

    const handleSearch = async () => {
        setSearchLoading(true);
        await getItems(1);
        setSearchLoading(false);
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('RequisitionNo', formData.RequisitionNo || "");
            params.append('Status', formData.Status.value || "");
            params.append('ReqType', formData.RequisitionType?.value || "");
            params.append('ReqType2', formData.RequisitionType?.value === "Purchase Requisition" ? "Purchase Request" : "Store Request");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
            params.append('WithoutPo', formData.withoutPo ? 1 : 0);
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);

            if (dateFilter === true) {
                params.append('FromDate', formData?.fromDate || "");
                params.append('ToDate', formData?.toDate || "");
            }
            const res = await apiService.getApiParamater('GET_PR_REPORT', `?${params.toString()}`);
            setRowData(res.data.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
            setFormData((prev) => ({
                ...prev,
                fromDate: formData.fromDate,
                toDate: formData.toDate,
            }));
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const Comparison = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        {
            headerName: "Requisition No", field: "requisitionNo", suppressMovable: true, width: 130,
            cellRenderer: (params) => {
                const { doctype } = params.data;
                const handleButtonClick = () => handlePrint(params.data);
                const buttonStyle = {
                    color: '#1032E7',
                    textDecoration: "underline",
                    border: "none",
                    backgroundColor: "#fff"
                };
                return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
            }
        },
        { headerName: 'Requisition Type', field: 'reqType', suppressMovable: true, width: 140 },
        { headerName: 'Requestor ', field: 'requestor', suppressMovable: true, width: 130 },
        {
            headerName: 'Requisition Date', field: 'requisitionDate', suppressMovable: true, width: 120, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Remarks', field: 'remarks', suppressMovable: true, width: 200 },
        { headerName: 'Curr Code', field: 'currencyCode', suppressMovable: true, width: 150 },
        { headerName: 'Exchange Rate', field: 'exchangeRate', suppressMovable: true, width: 110 },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 3)
        },
        {
            headerName: 'Status', field: 'status', suppressMovable: true, width: 110,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<div>Pending</div>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<div>Approved</div>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<div>Hold</div>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<div>Rejected</div>);
                } else {
                    return params.value;
                }
            }
        },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 110 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 110 },
        { headerName: 'Cost center 3', field: 'costCenter3', suppressMovable: true, width: 110 },
        { headerName: 'Cost center 4', field: 'costCenter4', suppressMovable: true, width: 110 },
        { headerName: 'Qoute No', field: 'costCenter', suppressMovable: true, width: 110 },
    ];
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'PurchaseRequsitionReport.csv'
        });
    }, []);
    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = [
            'recordId',
            'requestor',
            'requisitionDate',
            'costCenter1',
            'status',
            'itemCode',
            'itemDescription',
            'uom',
            'qty',
        ];
        const translateStatus = (status) => {
            switch (status) {
                case 1:
                    return 'Approved';
                case 0:
                    return 'Pending';
                case 2:
                    return 'Hold';
                case 3:
                    return 'Rejected';
                default:
                    return status;
            }
        };

        comparisonFields.forEach(field => {
            const header = Comparison.find(col => col.field === field).headerName;
            columnHeaders.push(header);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                let value = node.data[field];
                if (field === 'status') {
                    value = translateStatus(value);
                }
                row.push(value);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Purchase Requsition Report", 65, 12);
        doc.text("__________________________", 60, 15);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 6,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 6,
            },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20 },
                4: { cellWidth: 15 },
                5: { cellWidth: 20 },
                6: { cellWidth: 20 },
                7: { cellWidth: 15 },
                8: { cellWidth: 20 },
            },
            startY: 20
        });

        doc.save('PurchaseRequisitionReport.pdf');
    }, []);
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            const params = new URLSearchParams()
            params.append('RequisitionNo', formdata.RequisitionNo || "");
            params.append('Status', formdata.Status.value || "");
            params.append('ReqType', formdata.RequisitionType?.value || "");
            params.append('ReqType2', formdata.RequisitionType?.value === "Purchase Requisition" ? "Purchase Request" : "Store Request");
            params.append('StockType', formdata.StockType?.value?.stockTypeCode || "");
            params.append('WithoutPo', formdata.withoutPo ? 1 : 0);
            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);
            if (dateFilter === true) {
                params.append('FromDate', formdata?.fromDate || "");
                params.append('ToDate', formdata?.toDate || "");
            }
            const res = await apiService.getApiParamater('GET_PR_REPORT', `?${params.toString()}`);
            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                setLoading(false);
                return;
            }

            const totalAmount = allData.reduce((sum, item) => sum + (item.amount || 0), 0);

            const excelData = allData.map((item) => ({
                "Requisition NO": item.requisitionNo,
                "Requisition Type": item.reqType,
                "Requestor": item.requestor,
                "Requisition Date": moment(item.requisitionDate).format("DD-MMM-YYYY"),
                "Remarks": item.remarks,
                "Currency Code": item.currencyCode,
                "Exchange Rate": item.exchangeRate,
                "Amount": item.amount?.toFixed(currencyPrecision || 3),
                "Status": item.status === 1 ? "Approved" : item.status === 0 ? "Pending" : item.status === 5 ? "Hold" : "Rejected",
                "Property": item.costCenter1,
                "Unit": item.costCenter2,
                "Cost center 3": item.costCenter3,
                "Cost center 4": item.costCenter4,
            }));

            excelData.push({}); // Add an empty row for spacing

            const totalRow = {
                "Requisition NO": "",
                "Requisition Type": "",
                "Requestor": "",
                "Requisition Date": "",
                "Remarks": "",
                "Currency Code": "",
                "Exchange Rate": "Total",
                "Amount": Number(totalAmount || 0).toFixed(currencyPrecision || 3),
                "Status": "",
                "Property": "",
                "Unit": "",
                "Cost center 3": "",
                "Cost center 4": "",
            };
            excelData.push(totalRow);

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // Auto-fit column widths
            const columnWidths = Object.keys(excelData[0]).map((header) => {
                if (header === "itemDescription") {
                    return { wch: 60 };
                }
                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) =>
                        row[header] ? row[header].toString().length : 0
                    )
                );

                return {
                    wch: maxLength,
                };
            });

            worksheet["!cols"] = columnWidths;

            // Style for the total row
            const totalRowStyle = {
                font: { bold: true },
                fill: { fgColor: { rgb: "E0E0E0" } } // Light Grey
            };

            const range = XLSX.utils.decode_range(worksheet['!ref']);
            const totalRowIndex = excelData.length; 

            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: C });
                if (worksheet[cellAddress]) worksheet[cellAddress].s = totalRowStyle;
            }

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Requisition Report");

            XLSX.writeFile(workbook, "PRReport.xlsx");

            toast.success("PRReport.xlsx downloaded");
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    }, [currencyPrecision]);
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handleTypeChange = (selectedOption) => {
        setFormData({ ...formData, RequisitionType: selectedOption });
    }
    const handleStatusFilter = (selectedOption) => {
        if (selectedOption.label == "All") {
            handleClearFilters()
        } else {
            setFormData({ ...formData, Status: selectedOption });
        }
    }
    const SendEmail = async () => {
        try {
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                return;
            }
            const requestBody = {
                // toEmail: "shahzaibawan864@gmail.com",
                toEmail: formData.email,
                subject: "Requsition Report",
                body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #5B93FF; color: #fff;'>
                            <tr>
                                <th>PO No</th>
                                <th>Requisition NO </th>
                                <th>PO Date</th>
                                <th>Vendor</th>
                                <th>Payment Term</th>
                                <th>Supplier Contact</th>
                                <th>Department</th>
                                <th>Curr Code</th>
                                <th>status</th>
                                <th>Property</th>
                                <th>Unit</th>
                                <th>Cost center 3</th>
                                <th>Cost center 4</th>
                                <th>Delivery Status</th>
                                <th>Item Code</th>
                                <th>Item Description</th>
                                <th>UOM</th>
                                <th>QTY</th>
                                <th>Unit Price</th>
                                <th>Vat %</th>
                                <th>Vat Amount</th>
                                <th>Amount</th>
                                <th>Net Amount</th>
                                <th>GRN Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowData?.map((row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.pOrderNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.requisitionNo}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.docDate}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.vendorName}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.terms}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.attention}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.department}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.currencyCode}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.status}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter1}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter2}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter3}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter4}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.deliveryStatus}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemCode}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemDescription}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.uom}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.qty}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.unitPrice}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatPerc}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(currencyPrecision || 3) || 0}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.netAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.grnQty}' disabled /></td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>`
            }
            const apiService = new ApiService();
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                handleClearFilters()
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handlePrint = (data) => {
        if (!selectedRows.length || !data) return;
        let list = selectedRows?.length > 0 ? selectedRows : [data]
        const token = localStorage.getItem("Token");
        const DB = localStorage.getItem("DataBase");

        if (!token) {
            alert("Auth token is missing! Unable to proceed.");
            return;
        }

        selectedRows.forEach((row, index) => {
            setTimeout(() => {
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;

                const popup = window.open(
                    "",
                    `ReportPopup_${index}`,
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = REPORT_URL;
                    form.target = `ReportPopup_${index}`;

                    [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "PurchaseRequisition" },
                        { name: "voucherNo", value: row.requisitionNo },
                    ].forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
            }, index * 1000); // 1 second gap between each popup
        });
    };
    const onSelectionChanged = async (event) => {
        const rows = event.api.getSelectedRows();
        setSelectedRows(rows);
    };

    const handleShow = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'RequisitionSummary' },
                    { name: 'RequisitionType', value: formData?.RequisitionType?.value || "" },
                    { name: 'WithoutPO', value: formData.withoutPo ? '1' : '0' },
                    { name: 'StockTypeCode', value: formData?.StockType?.value?.stockTypeCode || '' },
                    { name: 'FromDate', value: formData?.fromDate || '' },
                    { name: 'toDate', value: formData?.toDate || '' },
                    { name: 'Status', value: formData?.Status?.value || '' },
                    { name: 'RequisitionNo', value: formData?.RequisitionNo || '' },
                ];
                debugger
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row pb-2' >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.RequisitionType}
                                options={requestType}
                                onChange={handleTypeChange}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleStockChange(selectedOption)}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                placeholder='Requisition No'
                                value={formData.RequisitionNo}
                                name="RequisitionNo"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={handleStatusFilter}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.fromDate}
                                disabled={!dateFilter}
                                onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                className="p-2 form-Input w-100"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.toDate}
                                onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                className="p-2 form-Input w-100"
                                disabled={!dateFilter}
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        {/* <div className='col start gap-3 mt-1'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                disabled
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div> */}
                        <div className='col start gap-3 mt-1'>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="Active"
                                style={{ width: "20px", height: "20px" }}
                                name="Active"
                                checked={formData.withoutPo}
                                onChange={handleCheckboxChange}
                            />
                            <label className=''>Without PO</label>
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => handleSearch()} className='mainbtnGry flex-end gap-2'>
                        {searchLoading ? (
                            <ClipLoader color='#fff' size={16} className='center mt-1 mx-2' />
                        ) : (
                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        )}
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Requisition Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtn flex-end gap-1' onClick={handleShow}>
                        <div className='center'>Show</div>
                    </div>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div
                        onClick={handlePrint}
                        className={`mainbtnRed flex-end ${selectedRows.length === 0 ? "disabled" : ""}`}
                        style={{
                            cursor: selectedRows.length > 0 ? "pointer" : "not-allowed"
                        }}
                    >
                        <HiOutlinePrinter size={25} color="#fff" className="center mt-1" />
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            columnDefs={Comparison}
                            suppressExcelExport={true}
                            ref={gridRef}
                            rowSelection="multiple"
                            onSelectionChanged={onSelectionChanged}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => onCloseModal()}
                onRequestClose={() => onCloseModal()}
                contentLabel='Email Modal'
                style={customStyles} closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={SendEmail} >Save</button>
                </Modal.Footer>
            </Modal >
        </div>
    );
};
export default PurchaseRequisitionReports;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};